function PhotoCompetitionTabs(el) {
    this.el = el;

    this.headerBtns = this.el.querySelectorAll('.jsHeaderBtn');
    this.tabs = this.el.querySelectorAll('.jsTab');

    this.headerBtns.forEach(btn => {
        btn.addEventListener('click', () => {
            this.tabs.forEach(tab => tab.classList.remove('active'));
            this.headerBtns.forEach(btn => btn.classList.remove('btn--darkblue'));
            btn.classList.add('btn--darkblue');

            const tab = this.el.querySelector(`.jsTab[data-tab="${btn.dataset.tab}"]`);
            tab.classList.add('active');
        });
    });
}

(function() {
    const tabEls = document.querySelectorAll('.jsFotowedstrijdInzendingenTabs');
    tabEls.forEach(el => new PhotoCompetitionTabs(el));
})();